import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import Sidebar from '../Sidebar';
import useScrolled from '../../hooks/useScrolled';

/**
 * Standard page frame: fixed header, optional left navigation, content, footer.
 * `sidebar` shows the desktop navigation column (`sidebarProps` are passed to it);
 * `narrow` caps the content at prose width.
 */
const PageShell = ({
    children,
    sidebar = false,
    sidebarProps,
    narrow = false,
    className = '',
    bodyClassName = '',
    mainClassName = '',
}) => {
    const scrolled = useScrolled();
    const shellClass = ['app', 'page-shell', narrow ? 'page-shell--narrow' : '', className].filter(Boolean).join(' ');

    return (
        <div className={shellClass}>
            <Header scrolled={scrolled} />
            <div className={['page-shell__body', bodyClassName].filter(Boolean).join(' ')}>
                {sidebar ? (
                    <aside className="page-shell__sidebar">
                        <Sidebar {...sidebarProps} />
                    </aside>
                ) : null}
                <main className={['page-shell__main', mainClassName].filter(Boolean).join(' ')}>
                    {children}
                </main>
            </div>
            <Footer />
        </div>
    );
};

export default PageShell;
